<template>
  <b-card :header="$t('project.schedulesExport.schedulesPage')">
    <div v-if="errored" class="alert alert-danger">{{errored}}</div>
    <div v-if="informed" class="alert alert-success">{{informed}}</div>

    <div role="tablist">
      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button
            block
            href="#"
            v-b-toggle.accordion-stations
            variant="info"
          >{{ $t('project.alarmsExport.selectStations') }}</b-button>
        </b-card-header>
        <b-collapse
          id="accordion-stations"
          visible
          accordion="accordion"
          v-model="accStations"
          role="tabpanel"
        >
          <b-card-body>
            <b-form-group>
              <b-form-radio-group id="stations" v-model="selected" stacked>
                <b-form-radio  v-for="(value, key) in stations" :key="key" :value="value.item3">{{ value.item2 }}</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
            <b-button
              class="mt-3"
              block
              variant="success"
              @click="selectStations()"
            >{{ $t('project.alarmsExport.selectStationsConfirm') }}</b-button>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button
            block
            href="#"
            v-b-toggle.accordion-status
            variant="info"
          >{{ $t('project.schedulesExport.schedulesTable') }}</b-button>
        </b-card-header>
        <b-collapse
          id="accordion-status"
          visible
          accordion="accordion"
          v-model="accStatus"
          role="tabpanel"
        >
          <b-card-body>
            <b-row class="my-1">
              <b-col sm="2">
                <label for="input-small">{{ $t('project.schedulesExport.schedulesType') }}</label>
              </b-col>
              <b-col sm="10">
                <b-form-input size="sm" :value="selected !== null ? getStationTitle() : ''" disabled />
              </b-col>
            </b-row>

            <b-row class="my-1">
              <b-col sm="2">
                <label for="input-small">{{ $t('project.schedulesExport.schedulesType') }}</label>
              </b-col>
              <b-col sm="10">
                <b-form-input size="sm" :value="schedule != null ? schedule.type : ''" disabled />
              </b-col>
            </b-row>

            <b-row class="my-1">
              <b-col sm="2">
                <label for="input-small">{{ $t('project.schedulesExport.schedulesStatus') }}</label>
              </b-col>
              <b-col sm="10">
                <b-form-input size="sm" :value="schedule != null ? schedule.status : ''" disabled />
              </b-col>
            </b-row>

            <b-row class="my-1">
              <b-col sm="2">
                <label for="input-small">{{ $t('project.schedulesExport.schedulesStatus') }}</label>
              </b-col>
              <b-col sm="10">
                <b-form-input size="sm" :value="schedule != null ? schedule.information : ''" disabled />
              </b-col>
            </b-row>

            <b-row class="my-1 mb-3">
              <b-col sm="2">
                <label for="input-small">{{ $t('project.schedulesExport.schedulesLastUpdate') }}</label>
              </b-col>
              <b-col sm="10">
                <b-form-input size="sm" :value="schedule != null ? getFormatDateString(schedule.lastUpdate) : ''" disabled />
              </b-col>
            </b-row>

            <div v-if="loading" class="mb-3 mt-3">
              <b-spinner label="Loading..."></b-spinner>
            </div>
            <div v-if="schedule !== null && schedule.schedulesTable !== null">
              <b-tabs content-class="mt-3 mb-3">
                <b-tab v-for="(valueTable, keyTable) in schedule.schedulesTable" :key="keyTable" class="mt-3 mb-3" :title="valueTable.header">
                  <b-table-simple v-for="(valueSection, keySection) in valueTable.sections" :key="keySection" class="my-1 mb-3" hover small caption-top responsive fixed>
                    <b-tbody>
                      <b-tr>
                        <b-td v-for="(valueSectionHeader, keySectionHeader) in valueSection.header" :key="keySectionHeader"><b>{{ valueSectionHeader }}</b></b-td>
                      </b-tr>
                      <b-tr v-for="(valuePart, keyPart) in valueSection.parts" :key="keyPart">
                        <b-td v-for="(valuePartV, keyPartV) in valuePart.values" :key="keyPartV">
                          <b-form-input
                            v-if="valuePartV !== null && valuePartV !== ''"
                            v-on:change="updateScheduleValue(keyTable, keySection, keyPart, keyPartV, $event)"
                            :value="valuePart.values[keyPartV]"
                            :state="checkIfNotUpdated(keyTable, keySection, keyPart, keyPartV)"
                            type="text"
                            size="sm"
                          />
                        </b-td>
                      </b-tr>
                    </b-tbody>
                  </b-table-simple>
                </b-tab>
              </b-tabs>
            </div>
            <b-alert
              class="mb-3 mt-3"
              :show="dismissCountDown"
              dismissible
              fade
              variant="warning"
              @dismiss-count-down="countDownChanged"
            >
              {{ dismissCountDown }} : {{ $t('project.schedulesExport.confirmationButton') }} <b-button size="sm" variant="outline-dark" @click="doAction()">{{ confirmationString }}</b-button>
            </b-alert>
            <b-button-group class="mb-3 mt-3">
              <b-button @click="showConfirmationAlert('Update')" v-b-tooltip.hover :title="$t('project.schedulesExport.buttonUpdateTitle')" variant="success">{{ $t('project.schedulesExport.buttonUpdate') }}</b-button>
              <b-button @click="showConfirmationAlert('Reset')" v-b-tooltip.hover :title="$t('project.schedulesExport.buttonResetTitle')" variant="outline-success">{{ $t('project.schedulesExport.buttonReset') }}</b-button>
              <b-button @click="showConfirmationAlert('Stop')" v-b-tooltip.hover :title="$t('project.schedulesExport.buttonStopTitle')" variant="outline-danger">{{ $t('project.schedulesExport.buttonStop') }}</b-button>
              <b-button @click="showConfirmationAlert('Delete')" v-b-tooltip.hover :title="$t('project.schedulesExport.buttonDeleteTitle')" variant="danger">{{ $t('project.schedulesExport.buttonDelete') }}</b-button>
            </b-button-group>
          </b-card-body>
        </b-collapse>
      </b-card>
    </div>
    <project-back-button />
  </b-card>
</template>

<script>
import { exportService, schedulesService } from "@/_services";
import { errorHandler } from "@/_helpers";
import { router } from "@/router";
import ProjectBackButton from "@/components/projects/ProjectBackButton";

export default {
  name: "ProjectSchedules",
  components: {
    projectBackButton: ProjectBackButton
  },
  data() {
    return {
      projectId: null,
      stations: [],
      accStations: true,
      accStatus: false,
      schedule: null,
      changeHistory: [],
      loading: false,
      errored: null,
      informed: null,
      selected: null,
      timer: null,
      dismissCountDown: 0,
      confirmed: false,
      confirmationString: null
    };
  },
  created() {
    this.projectId = parseInt(this.$route.params.projectId, 10);
    if (isNaN(this.projectId) || this.projectId < 0) {
      router.push("/error404");
      return;
    }

    exportService
      .getStationsForProjects(this.projectId)
      .then(response => {
        this.stations = response.data;
      })
      .catch(error => {
        this.errored = errorHandler(error);
      });
  },
  methods: {
    selectStations() {
      this.errored = null;
      this.informed = null;
      if (this.selected === null) return;
      this.schedule = null;
      schedulesService
        .postSchedulesRetrieval(this.projectId, this.selected)
        .then(response => {
          this.schedule = response.data;
          this.changeHistory = [];
          this.accStations = false;
          this.accStatus = true;
          this.loading = true;
          this.timer = setInterval(this.getScheduleRetrievalStatus, 2000);
        })
        .catch(error => {
          this.errored = errorHandler(error);
        });
    },
    getScheduleRetrievalStatus() {
      schedulesService
        .getSchedulesStatus(this.projectId, this.selected)
        .then(response => {
          this.schedule = response.data;
          this.changeHistory = [];
          if (this.schedule.status === "Calculated" || this.schedule.status === "InError") {
            this.loading = false;
            clearInterval(this.timer);
          }
        })
        .catch(error => {
          this.errored = errorHandler(error);
        })
    },
    getFormatDateString(value) {
      return new Date(value).toLocaleString();
    },
    checkIfNotUpdated(keyTable, keySection, keyPart, keyPartV) {
      for (let i = 0; i < this.changeHistory.length; i++) {
        if (this.changeHistory[i].table === keyTable &&
            this.changeHistory[i].section === keySection &&
            this.changeHistory[i].part === keyPart &&
            this.changeHistory[i].partValue === keyPartV)
          return false;
      }
      return null;
    },
    updateScheduleValue(keyTable, keySection, keyPart, keyPartV, newValue) {
      this.schedule.schedulesTable[keyTable].sections[keySection].parts[keyPart].values[keyPartV] = newValue;
      this.changeHistory.push(
        {
          table: keyTable,
          section: keySection,
          part: keyPart,
          partValue: keyPartV
        }
      );
    },
    getStationTitle() {
      return this.stations.find(x => x.item3 === this.selected).item2;
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
      if (dismissCountDown === 0) this.confirmed = false;
    },
    showConfirmationAlert(method) {
      this.confirmationString = method;
      this.confirmed = false;
      this.dismissCountDown = 10;
    },
    doAction() {
      this.dismissCountDown = 0;
      switch (this.confirmationString.toLowerCase()) {
        case "update":
          if (this.schedule === null || this.schedule.schedulesTable === null) break;
          this.updateSchedules();
          break;
        case "reset":
          this.resetSchedules();
          break;
        case "stop":
          this.stopSchedules();
          break;
        case "delete":
          this.deleteSchedules();
          break;
      }
    },
    updateSchedules() {
      if (this.changeHistory.length === 0) {
        return;
      }
      let jsonData = JSON.stringify({ schedulesTable: this.schedule.schedulesTable });
      schedulesService
        .postSchedulesUpdate(this.projectId, this.selected, jsonData)
        .then(response => {
          this.schedule = response.data;
          this.changeHistory = [];
          this.loading = true;
          this.timer = setInterval(this.getScheduleRetrievalStatus, 2000);
        })
        .catch(error => {
          this.errored = errorHandler(error);
        })
    },
    resetSchedules() {
      schedulesService
        .postSchedulesReset(this.projectId, this.selected)
        .then(response => {
          this.schedule = response.data;
          this.changeHistory = [];
          this.loading = true;
          this.timer = setInterval(this.getScheduleRetrievalStatus, 2000);
        })
        .catch(error => {
          this.errored = errorHandler(error);
        })
    },
    stopSchedules() {
      schedulesService
        .postSchedulesStop(this.projectId, this.selected)
        .then(response => {
          this.schedule = response.data;
          this.changeHistory = [];
        })
        .catch(error => {
          this.errored = errorHandler(error);
        })
    },
    deleteSchedules() {
      schedulesService
        .deleteSchedules(this.projectId, this.selected)
        .then(response => {
          if (response.data === true) {
            this.schedule = null;
            this.changeHistory = [];
            this.accStations = true;
            this.accStatus = false;
          } else {
            this.errored = this.$i18n.t("project.schedulesExport.notDeletedInfo");
          }
        })
        .catch(error => {
          this.errored = errorHandler(error);
        })
    }
  }
};
</script>
